import classnames from 'classnames'
import { FunctionalComponent } from 'preact'

export interface ClampLinesProps {
  id: string
  text: string
  className?: string
  lines: number
  innerElement?: 'div' | 'p' | 'span'
}

/**
 * @deprecated
 * This is a replacer of 'react-clamp-lines' library
 * the reason of the replacement is a migration to Preact X
 * It's worth to create a proper ClampLines component
 */
const ClampLines: FunctionalComponent<ClampLinesProps> = ({
  id,
  text,
  className,
  lines,
  innerElement: InnerElement = 'div'
}) => {
  return (
    <div className={classnames('clamp-lines', className)} style={{ wordBreak: 'break-word' }}>
      <InnerElement
        id={`clamped-content-${id}`}
        style={{
          display: '-webkit-box',
          WebkitLineClamp: lines,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden'
        }}
      >
        {text}
      </InnerElement>
    </div>
  )
}

export default ClampLines
